import {Injectable} from '@angular/core';
import {Observable, tap} from 'rxjs';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {AuthApiService} from '../../Services/Api/Auth/auth-api.service';
import {SessionManagerService} from '../../Services/Shared/session-manager.service';
import {UserSessionDto} from '../../Models/User/user-session.interface';
import {LanguageManagerService} from '../../Services/Shared/language-manager.service';
import packageJson from '@packageJson';

@Injectable()
export class InterceptorProvider implements HttpInterceptor {

  user: UserSessionDto | null = null;

  constructor(
    protected readonly auth: AuthApiService,
    protected readonly sessionManager: SessionManagerService,
    protected readonly languageManager: LanguageManagerService,
  ) {
  }


  /**
   * Intercepta las peticiones Http y si el usuario está registrado le añade el token de autenticación
   *
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addToken(request)).pipe(
      tap((evt) => {

        if (evt instanceof HttpResponse) {

          if (evt.body?.status && evt.body.status == -1) {
            this.sessionManager.handleSessionExpired(true);
          }

        }

      }));
  }


  /**
   * Añade el token en los Headers si hay sesion de usuairo y existe el token
   *
   */
  private addToken(request: HttpRequest<any>): HttpRequest<any> {
    const commonHeaders: any = {
      Accept: 'application/json',
      'Accept-Language': this.languageManager.currentLanguage || 'es',
      'X-App-Version': packageJson.version,
      'X-App-Identifier': 'io.roocket.yurestv2',
    };

    this.user = this.auth.getUserSession();

    if (this.user && 'token' in this.user) {

      return request.clone({
        setParams: {
          'user-key': '' + this.user.id + ''
        },
        setHeaders: {
          ...commonHeaders,
          Authorization: '' + this.user.token + '',
        }
      });

    }

    return request.clone({
      setHeaders: commonHeaders
    });
  }

}
